import Validator from "validatorjs";
import { cloneDeep, isEmpty, forEach } from "@utils/lodash";

export default class FormUtils {
	/**
	 * Validates form data using the `validatorjs` package
	 * @param {Object} formData Form data to be validated
	 * @returns {Object} an object with properties `form : Object`, `isValid : boolean`, and `values : Object`
	 *
	 * @deprecated This method should no longer be used anywhere as we are attempting to remove `validatorjs` from this project.
	 * Any form validation should be done locally and without using `validatorjs` or this utility function.
	 */
	static validateForm = formData => {
		const form = cloneDeep(formData);

		const rules = FormUtils.getRules(form);
		const values = FormUtils.getValues(form);

		const validation = new Validator(values, rules);
		const isValid = validation.passes();

		forEach(form, (value, key) => {
			form[key].validation = !isEmpty(validation.errors.get(key)) ? "error" : null;
		});

		return {
			form,
			isValid,
			values,
		};
	};

	/**
	 * @deprecated Parses validation rules from form data to implement using `validatorjs`
	 * @param {Object} form The form to retrieve rules from
	 * @returns {Object} an object containing all validation rules for the provided form
	 */
	static getRules = form =>
		Object.keys(form).reduce(
			(p, c) => (isEmpty(form[c].rules) ? { ...p } : { ...p, [c]: form[c].rules }),
			{},
		);

	/**
	 * @deprecated Parses values from form data to test using `validatorjs`
	 * @param {Object} form The form to retrieve values from
	 * @returns {Object} an object containing all key-value pairs from the provided form
	 */
	static getValues = form =>
		Object.keys(form).reduce(
			(p, c) => ({
				...p,
				[c]: form[c].value,
			}),
			{},
		);
}
